import { LoadingPresenter } from '~/components/loading/Presenter';
import { useLoadingContext } from '~/context/LoadingContext';

export const LoadingContainer = () => {
  const { isLoading, color } = useLoadingContext();

  return isLoading ? <LoadingPresenter color={color} /> : <></>;
};
